import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MailType, MailVariables } from 'shared';

import { Box } from '@sam/components';
import { IconComponent, IconType } from '../icons/IconComponent';

interface MailInfoProps {
  type?: MailType;
}

export const MailVariableInfo: React.FC<MailInfoProps> = ({ type }) => {
  const { t } = useTranslation();
  const defaultVariables: MailVariables[] = useMemo(
    (): MailVariables[] => [
      MailVariables.CUSTOMER_NAME,
      MailVariables.GREETING,
      MailVariables.USER_FIRSTNAME,
      MailVariables.USER_LASTNAME,
      MailVariables.CUSTOMER_CONTACT_NAME,
      MailVariables.SIGNATURE,
    ],
    [],
  );
  const [availableVariables, setAvailableVariables] = useState<MailVariables[]>(defaultVariables);
  const [isOpen, toggleOpen] = useState<boolean>(false);

  //Hook to update the Mailvariables for a given mailType
  useEffect(() => {
    switch (type) {
      case MailType.DUNNING:
        setAvailableVariables([
          ...defaultVariables,
          MailVariables.ORDER_NUMBER,
          MailVariables.CREATE_DATE,
          MailVariables.DUNNING_LEVEL,
          MailVariables.DUNNING_DUE_ON,
          MailVariables.COMPANY,
          MailVariables.DUE_ON,
        ]);
        break;
      case MailType.OFFER:
        setAvailableVariables([...defaultVariables, MailVariables.OFFER_NUMBER]);
        break;
      case MailType.INVOICE:
        setAvailableVariables([
          ...defaultVariables,
          MailVariables.PROJECT_NUMBER,
          MailVariables.RECEIPT_NUMBER,
          MailVariables.ORDER_NUMBER,
        ]);
        break;

      case MailType.DELIVERY_NOTE:
        setAvailableVariables([...defaultVariables, MailVariables.DELIVERY_NOTE_NUMBER]);
        break;
      case MailType.ORDER_CONFIRMATION:
        setAvailableVariables([...defaultVariables, MailVariables.PROJECT_NUMBER]);
        break;
      case MailType.CREDIT_NOTE:
        setAvailableVariables([
          ...defaultVariables,
          MailVariables.PROJECT_NUMBER,
          MailVariables.RECEIPT_NUMBER,
          MailVariables.CREDIT_NOTE_NUMBER,
          MailVariables.ORDER_NUMBER,
        ]);
        break;
      case MailType.CANCEL_RECEIPT:
        setAvailableVariables([
          ...defaultVariables,
          MailVariables.PROJECT_NUMBER,
          MailVariables.RECEIPT_NUMBER,
          MailVariables.CANCEL_RECEIPT_NUMBER,
          MailVariables.ORDER_NUMBER,
        ]);
        break;
      case MailType.PROTOCOL:
        setAvailableVariables([...defaultVariables, MailVariables.PROJECT_NUMBER]);
        break;
      case MailType.CAR_INSPECTION:
      case MailType.CAR_LEASING_END:
        setAvailableVariables([
          MailVariables.CAR_ASSIGNED_USER,
          MailVariables.CAR_BRAND,
          MailVariables.CAR_INSPECTION_DATE,
          MailVariables.CAR_MODEL,
          MailVariables.REGISTRATION_PLATE,
          MailVariables.LEASING_END_DATE,
        ]);
        break;
      default:
        break;
    }
  }, [defaultVariables, type]);

  return (
    <Box title={t('pages.mailConfig.edit.availableValues')}>
      <div className="mail-variables__wrapper">
        <IconComponent
          type={IconType.UP_ARROW}
          className={`mail-variables__wrapper__${isOpen ? 'up' : 'down'}-arrow`}
          onClick={() => toggleOpen(!isOpen)}
        />

        {isOpen && (
          <ul className="three-columns">
            {availableVariables.map((value) => (
              <li className="mail-variables__wrapper__values__value" key={value}>
                {t(`general.mailVariables.placeholder.${value}`)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </Box>
  );
};
